import { Grid } from '@mui/material'
import LoadingModal from './components/Common/LoadingModal'
import Navbar from './components/Layout/Navbar/Navbar'
import MainContent from './components/Layout/MainContent'
import { useEffect } from 'react'
import { initGA, RouteTracker } from './analytics'
import useAppInitiator from './CustomHooks/useAppInitializer'
import './i18n'

const App: React.FC = () => {
    const initializingApp = useAppInitiator()

    useEffect(() => {
        const measurementId: string =
            import.meta.env.VITE_GA_MEASUREMENT_ID || ''
        initGA(measurementId)
    }, [])

    if (initializingApp) {
        return <LoadingModal open={true} />
    }

    return (
        <Grid container>
            <RouteTracker />
            <Grid>
                <Navbar />
            </Grid>
            <main id="main-content" tabIndex={-1} style={{ width: '100%' }}>
                <MainContent />
            </main>
            <LoadingModal />
        </Grid>
    )
}

export default App
